/**
 * Settling a streamed assistant message that did not finish cleanly.
 *
 * A reply ends with a "done" or an "error" event. If the connection closes
 * with neither, the bubble must not keep its streaming cursor forever -- that
 * read as a hung chat (2026-10-27). Text that already arrived is kept; the
 * error is appended rather than written over it.
 */

export const STREAM_INCOMPLETE_MESSAGE =
  'The response stopped before it finished. Please try again.';

export const DEFAULT_STREAM_ERROR =
  'An error occurred while generating the response.';

/** True once an event has settled the message, so the stream may end. */
export const isTerminalStreamEvent = (event) =>
  event?.type === 'done' || event?.type === 'error';

/** The text to show for a failed reply: partial content first, then the error. */
export const failedReplyContent = (partialContent, error) => {
  const message = error || DEFAULT_STREAM_ERROR;
  const partial = (partialContent || '').trimEnd();
  return partial ? `${partial}\n\n${message}` : message;
};

/** Mark one message in the list as a failed, no-longer-streaming reply. */
export const markReplyFailed = (messages, messageId, partialContent, error) =>
  messages.map((msg) => (
    msg.id === messageId
      ? {
          ...msg,
          content: failedReplyContent(partialContent, error),
          isStreaming: false,
          isError: true,
          toolActivity: null,
        }
      : msg
  ));
